import React from 'react'

import PageTitle from '../../../global/PageTitle/PageTitle'
import ListTable from '../../../global/ListTable/ListTable'
import './TaxDocument.css'

const columns = [
    { key: 'taxYear', label: 'Tax Year' },
    { key: 'company', label: 'Company' },
    { key: 'taxForm', label: 'Tax Form' },
    { key: 'document', label: 'Tax Document PDF' }
]

const rows = []

const TaxDocument = () => {
    return (
        <div>
            <PageTitle title="My Tax Documents" />
            <div className="taxDocument-main">
                <ListTable columns={columns} rows={rows} />
            </div>
        </div>
    )
}

export default TaxDocument
